import './FilterOptionThirdLevelCollections.scss';

import type { FilterOptionItemSettings } from '@components/FilterOptionItem';
import { FilterOptionItem } from '@components/FilterOptionItem';
import FilterOptionItemButton from '@components/FilterOptionItem/Button';
import FilterOptionItemLabel from '@components/FilterOptionItem/Label';
import type {
  FilterOptionCollectionItemHookProps,
  FilterOptionCollectionItemProps,
} from '@components/FilterOptionMultiLevelCollections';
import { createClsNameMap, stripHtml } from '@utils';

export const clsNameMap = createClsNameMap({
  elements: {
    title: createClsNameMap(),
  },
})('filter-option-item-multilevel-collections-thirdlevel');

export type FilterOptionThirdLevelCollectionsItemProps = {
  collectionId: string;
  collectionHandle: string;
  useFilterOptionCollectionItem: (
    item: FilterOptionCollectionItemHookProps
  ) => FilterOptionCollectionItemProps;
  value: {
    tag: string;
    displayName: string;
    settings: FilterOptionItemSettings;
  };
};

export type FilterOptionThirdLevelCollectionsProps = {
  collectionId: string;
  collectionHandle: string;
  useFilterOptionCollectionItem: (
    item: FilterOptionCollectionItemHookProps
  ) => FilterOptionCollectionItemProps;
  options: Array<FilterOptionThirdLevelCollectionsItemProps['value']>;
};

const FilterOptionThirdLevelCollectionsItem = ({
  collectionHandle,
  value: { tag, displayName, settings },
  collectionId,
  useFilterOptionCollectionItem,
}: FilterOptionThirdLevelCollectionsItemProps) => {
  const { collectionUrlPath, isOptionItemSelected, handleSelectOptionItem } =
    useFilterOptionCollectionItem({
      collectionId,
      collectionHandle,
      tag,
    });

  if (!stripHtml(displayName)) return null;

  return (
    <FilterOptionItem as='li' className={clsNameMap.elm('title')}>
      <FilterOptionItemButton
        as='link'
        isSelected={isOptionItemSelected}
        label={<FilterOptionItemLabel settings={settings} label={displayName} />}
        link={collectionUrlPath}
        onClick={(e: Event) => handleSelectOptionItem(e)}
      />
    </FilterOptionItem>
  );
};

const FilterOptionThirdLevelCollections = ({
  options,
  collectionId,
  collectionHandle,
  useFilterOptionCollectionItem,
}: FilterOptionThirdLevelCollectionsProps) => {
  return (
    <ul className={clsNameMap.root()}>
      {options.map((option) => (
        <FilterOptionThirdLevelCollectionsItem
          key={option.tag}
          collectionId={collectionId}
          collectionHandle={collectionHandle}
          useFilterOptionCollectionItem={useFilterOptionCollectionItem}
          value={option}
        />
      ))}
    </ul>
  );
};

export default FilterOptionThirdLevelCollections;
